// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"ae7bc7d9","630":"83b9a36c","797":"ae7bc7d9","894":"d3c79b8c"}[chunkId] + ".chunk.css";
};